import {
  TransactionRuleType,
  TransactionRuleUse,
} from '../reducers/admin/transactionRulesReducer'
import { SelectDropdownOption } from '@/ui'

// Mirror of the API-side enum (apps/api/src/api/component/transactions/transaction_rule.constants.ts).
export enum ArchiveReason {
  DUPLICATE = 'DUPLICATE',
  LOW_ACCURACY = 'LOW_ACCURACY',
  STALE = 'STALE',
  USER_REQUEST = 'USER_REQUEST',
  OTHER = 'OTHER',
}

const valsToDropdownOptions = <T extends string>(
  optionValues: readonly T[],
  formatLabel?: (enumValue: T) => string
): SelectDropdownOption<T>[] =>
  optionValues.map((val) => ({
    key: val,
    text: formatLabel ? formatLabel(val) : val,
    value: val,
  }))

export const RULE_USE_OPTIONS = valsToDropdownOptions<TransactionRuleUse>([
  TransactionRuleUse.CLARIFICATION,
  TransactionRuleUse.CATEGORIZATION,
])

export const RULE_TYPE_OPTIONS = valsToDropdownOptions<TransactionRuleType>([
  TransactionRuleType.EXACT_MATCH,
  TransactionRuleType.CONTAINS_WORD,
  TransactionRuleType.REGEX,
  TransactionRuleType.MATCHES_DPF_CATEGORY,
  TransactionRuleType.MATCHES_MERCHANT_NAME,
])

const ARCHIVE_REASON_LABELS: Record<ArchiveReason, string> = {
  [ArchiveReason.DUPLICATE]: 'Duplicate',
  [ArchiveReason.LOW_ACCURACY]: 'Low accuracy',
  [ArchiveReason.STALE]: 'Stale',
  [ArchiveReason.USER_REQUEST]: 'User request',
  [ArchiveReason.OTHER]: 'Other',
}

export const ARCHIVE_REASON_DESCRIPTIONS: Record<ArchiveReason, string> = {
  [ArchiveReason.DUPLICATE]: 'A duplicate of another active rule.',
  [ArchiveReason.LOW_ACCURACY]:
    'This rule has been miscategorizing transactions or matches too broadly.',
  [ArchiveReason.STALE]:
    'This rule has not autocategorized any transactions in a long time.',
  [ArchiveReason.USER_REQUEST]: 'Archived at a user / customer request.',
  [ArchiveReason.OTHER]:
    'None of the above applies — please describe the reason below.',
}

export const ARCHIVE_REASON_OPTIONS = valsToDropdownOptions<ArchiveReason>(
  Object.values(ArchiveReason),
  (val) => ARCHIVE_REASON_LABELS[val]
)
